export function getTranslationsPage3(newOtherInformation, localizedStrings) {
  newOtherInformation.birthdate.elementConfig.label =
    localizedStrings.applicationpage.dateOfBirth;
  newOtherInformation.gendercode.elementConfig.label =
    localizedStrings.applicationpage.gender;
  newOtherInformation.mshied_firstgeneration.elementConfig.aboveText =
    localizedStrings.applicationpage.areyouFirstGeneration;
  newOtherInformation.usb_nativelanguage.elementConfig.label =
    localizedStrings.applicationpage.nativeLanguage;
  newOtherInformation.usb_areyouavisibleminority.elementConfig.label =
    localizedStrings.applicationpage.areyouaVisibleMinority;

  newOtherInformation.gendercode.elementConfig.options =
    newOtherInformation.gendercode.elementConfig.options.map((option) => {
      if (option.value === 1) {
        return {
          ...option,
          displayValue: localizedStrings.applicationpage.male,
        };
      } else if (option.value === 2) {
        return {
          ...option,
          displayValue: localizedStrings.applicationpage.female,
        };
      } else if (option.value === 943240003) {
        return {
          ...option,
          displayValue: localizedStrings.applicationpage.nonbinary,
        };
      } else if (option.value === 943240010) {
        return {
          ...option,
          displayValue: localizedStrings.applicationpage.termransgender,
        };
      } else if (option.value === 943240005) {
        return {
          ...option,
          displayValue: localizedStrings.applicationpage.twospirit,
        };
      } else if (option.value === 943240011) {
        return {
          ...option,
          displayValue: localizedStrings.applicationpage.genderother,
        };
      } else if (option.value === 943240009) {
        return {
          ...option,
          displayValue: localizedStrings.applicationpage.iprefernottoanswer,
        };
      }
      return option;
    });
  newOtherInformation.mshied_firstgeneration.elementConfig.options =
    newOtherInformation.mshied_firstgeneration.elementConfig.options.map(
      (option) => {
        if (option.value === true) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.yes,
          };
        } else if (option.value === false) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.no,
          };
        }
        return option;
      },
    );
  newOtherInformation.usb_areyouavisibleminority.elementConfig.options =
    newOtherInformation.usb_areyouavisibleminority.elementConfig.options.map(
      (option) => {
        if (option.value === true) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.yes,
          };
        } else if (option.value === false) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.no,
          };
        }
        return option;
      },
    );
  newOtherInformation.usb_nativelanguage.elementConfig.options =
    newOtherInformation.usb_nativelanguage.elementConfig.options.map(
      (option) => {
        if (option.value === 943240000) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.english,
          };
        } else if (option.value === 943240001) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.french,
          };
        } else if (option.value === 943240002) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.frenchenglish,
          };
        } else if (option.value === 943240003) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.otherlanguage,
          };
        }
        return option;
      },
    );
  return newOtherInformation;
}


export function getTranslationsPage3PartOne(
  newOtherInformation,
  localizedStrings,
) {
  newOtherInformation.usb_indigenousancestry.elementConfig.label =
    localizedStrings.applicationpage.canadianIndigenousancestry;
  newOtherInformation.usb_indigenousancestrytype.elementConfig.label =
    localizedStrings.applicationpage.answeredyes;
  newOtherInformation.usb_indigenousancestry.elementConfig.options =
    newOtherInformation.usb_indigenousancestry.elementConfig.options.map(
      (option) => {
        if (option.value === 1) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.yes,
          };
        } else if (option.value === 0) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.no,
          };
        }
        return option;
      },
    );
  newOtherInformation.usb_indigenousancestrytype.elementConfig.options =
    newOtherInformation.usb_indigenousancestrytype.elementConfig.options.map(
      (option) => {
        if (option.value === 943240000) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.firstNations,
          };
        } else if (option.value === 943240001) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.métis,
          };
        } else if (option.value === 943240002) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.inuit,
          };
        }
        return option;
      },
    );
  return newOtherInformation;
}
export function getTranslationsPage3PartTwo(
  newOtherInformation,
  localizedStrings,
) {
  newOtherInformation._ses_recruiter_value.elementConfig.aboveText =
    localizedStrings.applicationpage.recruitmentAgents;
  newOtherInformation._ses_recruiter_value.elementConfig.options =
    newOtherInformation._ses_recruiter_value.elementConfig.options.map(
      (option) => {
        if (option.value === "") {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.selectaRecruiter,
          };
        }
        return option;
      },
    );
  return newOtherInformation;
}
